<template>
  <div class="service-record">
    <van-cell-group inset>
        <van-cell title="日期筛选"/>
        <van-cell title="当前选择" :value="currentDateStr" @click="dateChoose()" is-link/>
    </van-cell-group>
    <van-popup v-model="showPicker" round position="bottom">
      <van-datetime-picker v-model="currentDate" type="year-month" title="" :min-date="minDate" :max-date="maxDate" @confirm="confirmcurrentDate" @cancel="showPicker=false"/>
    </van-popup>

    <van-cell-group inset>
        <van-cell title="记录操作统计（次）：" :value="recordForm.total"/>
        <van-cell title="患者服务（次）：" :value="recordForm.service"/>
        <van-cell title="用药回访（次）：" :value="recordForm.patient_visit"/>
        <van-cell title="医护拜访（次）：" :value="recordForm.doctor_visit"/>
        <van-cell title="监督发药（次）：" :value="recordForm.dispense"/>
        <van-cell title="盘点库存（次）：" :value="recordForm.take"/>
    </van-cell-group>

    <van-cell-group inset>
        <van-cell title="辅助操作统计（次）：" :value="recordForm.category_total "/>
        <van-cell title="上传入组材料（次）：" :value="recordForm['上传入组材料']" is-link @click="goList(recordForm['上传入组材料'],'上传入组材料')"/>
        <van-cell title="上传领药材料（次）：" :value="recordForm['上传领药材料']" is-link @click="goList(recordForm['上传领药材料'],'上传领药材料')"/>
        <van-cell title="开启下一阶段援助（次）：" :value="recordForm['开启下一阶段援助']" is-link @click="goList(recordForm['开启下一阶段援助'],'开启下一阶段援助')"/>
        <van-cell title="上传阶段审核材料（次）：" :value="recordForm['上传阶段审核材料']" is-link @click="goList(recordForm['上传阶段审核材'],'上传阶段审核材料')"/>
        <van-cell title="上传解锁材料（次）：" :value="recordForm['上传解锁材料']" is-link @click="goList(recordForm['上传解锁材料'],'上传解锁材料')"/>
    </van-cell-group>

  </div>
</template>

<script>
import Vue from 'vue';
import { List } from 'vant';
import { Divider } from 'vant';
import { getVolunteerServiceRecords } from '@/api/publicWelfareStaff';
import { mapState } from "vuex";
Vue.use(Divider);
Vue.use(List);
export default {
    data(){
        return {
          // 日期选择
          currentDateStr: "请选择",
          currentDate: new Date(),
          minDate: new Date(1949, 10, 1),
          maxDate: new Date(),
          showPicker: false, 

          // 统计列表
          recordForm:{},

          //无限加载列表
          list: [],
          loading: false,
          finished: false,
        }
    },
    computed: {
      ...mapState(['publicWelfareStaff'])
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        let currentData = new Date()
        this.currentDateStr = this.timeFormat(currentData)
        console.log("this.currentDateStr",this.currentDateStr)
        this.getRecordData(this.currentDateStr)  // 获取统计数据
      },
      // 获取统计数据
      async getRecordData(date) {
        console.log("获取统计数据")
        await getVolunteerServiceRecords({
          volunteer_id: this.publicWelfareStaff.checkin_info.papid,
          date: date,
        }).then((res) => {
          console.log("服务记录：",res)
          this.recordForm = res.data
          console.log("this.recordForm",this.recordForm)
        })
      },
      goList(times,title) {
        console.log("次数",times)
        this.$router.push({
          name:"patientList",
          query:{
            times: times+'',
            title: title,
            date: this.currentDateStr,
          }
        })
      },
      timeFormat(time) {
          let year = time.getFullYear();
          let month = time.getMonth() + 1;
          // let day = time.getDate();
          let month_str = ""
          if(month < 10){
            month_str = '0' + month
            console.log("month_str",month_str)
          }else {
            month_str = month
          } 
          return year + '-' + month_str;
      },
      dateChoose(){
        console.log("xxx")
        this.showPicker = true
      },
      confirmcurrentDate(value) {
        console.log("确定选择时间",value)
        this.currentDateStr=this.timeFormat(value)
        this.getRecordData(this.currentDateStr)  // 获取统计数据
        this.showPicker=false;
      },
    }
}
</script>

<style lang="scss" scoped>
.service-record{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    padding-top:15px;
    font-size: 16px;
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
    }
    .van-cell__title{
      flex: none;
    }
}
</style>